import { Fragment, useEffect, useState } from 'react';
import Checkbox from '../../../../../core/components/atoms/Checkbox';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Select, iOption } from '../../../../../core/components/atoms/Select';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { practiceConfigStore } from '../../../stores/practiceConfigStore';
import { SectionContainer } from '../../../components/SectionContainer';
import { useEssayCoreStore } from '../../../../../core/stores/essayCoreStore';
import { useGetThemeAxis } from '../../../../../core/hooks/useGetThemeAxis';
import CustomRadio from '../../../components/LabelFlexRadio';
import { useGetUserCredit } from '../../../hooks/getUserCredits';
import { LoadingIcon } from 'morpheus-ui';

export function EssaySection() {
  const { mutate: userCredits, data: credits, isPending } = useGetUserCredit();

  const { setHasEssay, hasEssay, setEssayCorrectionType, setEssayThemeAxis } =
    practiceConfigStore();
  const { themeAxis: axisList } = useEssayCoreStore();
  const { mutate } = useGetThemeAxis();

  const [correctionType, setCorrectionType] = useState<iOption>({
    label: 'ENEM',
    value: 'enem',
  });
  const [correctionTheme, setCorrectionTheme] = useState<string>('all');
  const [themeAxis, setThemeAxis] = useState<iOption>();
  const [axisArray, setAxisArray] = useState<iOption[]>([]);

  useEffect(() => {
    userCredits();
  }, []);

  useEffect(() => {
    if (correctionType) {
      setEssayCorrectionType(correctionType.value.toString());
    }
  }, [correctionType]);

  useEffect(() => {
    if (themeAxis) {
      setEssayThemeAxis(themeAxis.value.toString());
    }
  }, [themeAxis]);

  useEffect(() => {
    if (axisList && axisList.length > 0) {
      const newArray = axisList.map((it: any) => {
        return {
          label: it.title,
          value: it.id,
        };
      });

      setAxisArray(newArray);
    }
  }, [axisList]);

  useEffect(() => {
    if (correctionTheme === 'axis') {
      mutate();
    } else {
      setEssayThemeAxis('');
      setThemeAxis(undefined);
    }
  }, [correctionTheme]);

  return (
    <SectionContainer title='Redação'>
      <div className='flex flex-col gap-lg'>
        {isPending ? (
          <LoadingIcon className='stroke-current h-10 animate-spin fill-none text-center' />
        ) : (
          <Checkbox
            onChange={() => setHasEssay(!hasEssay)}
            label='Incluir redação na prova'
            checked={hasEssay}
            id='has-essay-too'
            value='essay'
            variant='rounded'
            disabled={credits?.remainingCreditsMonth === 0}
          />
        )}

        <div className='flex flex-row items-center gap-xs'>
          <Icon
            Icon='info'
            type='material'
            className='text-md text-mono-color-darkest'
          />
          <Typography size='small'>
            Ao finalizar o simulado, a redação será enviada para correção e será
            subtraído 1 crédito.
          </Typography>
        </div>
      </div>
      {hasEssay && (
        <Fragment>
          <Select
            options={[
              { label: 'ENEM', value: 'enem' },
              { label: 'Vestibulares', value: 'vestibulares' },
            ]}
            label='Banca de correção'
            onChange={(value) => setCorrectionType(value)}
            value={correctionType}
          />
          <div className='flex flex-col gap-xl'>
            <Typography>Tema de redação:</Typography>
            <CustomRadio
              value='axis'
              checked={correctionTheme}
              setData={(value) => setCorrectionTheme(value)}
            >
              <div className='flex w-full gap-sm xs:flex-col xs:items-start lg:flex-row lg:items-center'>
                <Typography>Usar tema do eixo temático:</Typography>
                <Select
                  options={axisArray}
                  label='Eixo temático'
                  onChange={(value) => setThemeAxis(value)}
                  value={themeAxis}
                  className='xs:w-full lg:w-1/5'
                  disabled={correctionTheme !== 'axis'}
                />
              </div>
            </CustomRadio>
            <CustomRadio
              value='all'
              checked={correctionTheme}
              setData={(value) => setCorrectionTheme(value)}
            >
              <Typography>Usar tema aleatório</Typography>
            </CustomRadio>
          </div>
        </Fragment>
      )}
    </SectionContainer>
  );
}
